module.exports = __webpack_public_path__ + "static/media/booking7.86d9dcdb.jpg";